import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useModalDismiss } from "./useModalDismiss";

interface Props {
    title: string;
    placeholder?: string;
    confirmLabel?: string;
    onConfirm: (value: string) => void;
    onCancel: () => void;
}

export default function PromptModal({
    title,
    placeholder = "",
    confirmLabel = "Insert",
    onConfirm,
    onCancel,
}: Props) {
    const [value, setValue] = useState("");
    const pendingRef = React.useRef<string | null>(null);
    const { show, dismiss, onExited } = useModalDismiss(onCancel, () => {
        if (pendingRef.current !== null) onConfirm(pendingRef.current);
    });

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        const v = value.trim();
        if (!v) return;
        pendingRef.current = v;
        dismiss("save");
    }

    return (
        <Modal show={show} onHide={() => dismiss("cancel")} onExited={onExited} centered backdropClassName="m-modal-backdrop">
            <form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title style={{ fontSize: 17, fontWeight: 600 }}>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <input
                        type="text"
                        className="m-input"
                        value={value}
                        onChange={e => setValue(e.target.value)}
                        placeholder={placeholder}
                        autoFocus
                    />
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="m-btn m-btn-ghost" onClick={() => dismiss("cancel")}>Cancel</button>
                    <button type="submit" className="m-btn m-btn-primary" disabled={!value.trim()}>
                        {confirmLabel}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
}
